<template>
  <div class="po-date" style="width:780px;margin:0 auto;background-color:#fff;">
    <div style="text-align:center;margin-top:20px;font-size:20px;">PO <a @click="$open(`/po-order-view/${doc.id}`, 840)">CYS{{ doc.id }}</a></div>
    <div style="text-align:center;margin-top:10px;">Entering Date:
      <el-date-picker v-model="form.date" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :picker-options="pickerOptions" style="width:150px;"></el-date-picker>
      <el-button @click="setToday" style="margin-left:10px;">Today</el-button>
      <el-button @click="setYesterday">Yesterday</el-button>
      <el-button type="primary" @click="saveDate">Save</el-button>
    </div>
    <table style="margin-top:20px;">
      <tr>
        <th>#</th>
        <th>Item</th>
        <th>Incoming</th>
        <th><el-button icon="el-icon-d-arrow-right" @click="allArrived"></el-button></th>
        <th>Arrived</th>
        <th>Balance</th>
        <th>Remark</th>
        <th>Picture</th>
        <th>&nbsp;</th>
      </tr>
      <tr v-for="(item, index) in productList">
        <td>{{ index + 1 }}</td>
        <td>
          {{ item.part_no }}<br/>
          {{ item.description }}<br/>
          {{ item.brand }}
        </td>
        <td style="text-align:right;">{{ productList[index].qty }}</td>
        <td style="text-align:center;"><el-button icon="el-icon-arrow-right" @click="arrived(index)"></el-button></td>
        <td><el-input v-model.number="productList[index].arrived" class="input-number" style="width:80px;"></el-input></td>
        <td style="text-align:right;" v-if="productList[index].qty === productList[index].arrived">0</td>
        <td style="text-align:right;color:red;" v-else>{{ productList[index].qty - productList[index].arrived }}</td>
        <td><el-input v-model="productList[index].arrived_remark"></el-input></td>
        <td style="text-align:center;">
          <a @click="$open(`/order-photo/po/${doc.id}`, 800)">
            <i class="el-icon-picture" style="color:#424242;font-weight:bold;"></i>
          </a>
        </td>
        <td><el-button type="primary" @click="save">Submit</el-button></td>
      </tr>
    </table>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data () {
    return {
      form: {
        date: null
      },
      doc: {},
      productList: [],
      pickerOptions: {
        shortcuts: [{
          text: 'today',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: 'yesterday',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: 'a week ago',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }]
      }
    }
  },
  mounted () {
    this.fetchDoc()
    this.fetchProductList()
  },
  methods: {
    fetchDoc () {
      this.$http.get('/dbapi/po_doc_list?id=' + this.$route.params.id).then(data => {
        if (data.list.length > 0) {
          this.doc = data.list[0]
          //this.form.date = this.doc.delivery_date
        }
      })
    },
    fetchProductList () {
      this.$http.get('/dbapi/po_doc_details?id=' + this.$route.params.id).then(data => {
        this.productList = data.list
      })
    },
    setToday () {
      this.form.date = moment().format('YYYY-MM-DD')
    },
    setYesterday () {
      let date = new Date()
      date.setTime(date.getTime() - 3600 * 1000 * 24)
      this.form.date = moment(date).format('YYYY-MM-DD')
    },
    arrived (i) {
      this.productList[i].arrived = this.productList[i].qty
    },
    allArrived () {
      for (let i = 0; i < this.productList.length; i++) {
        this.productList[i].arrived = this.productList[i].qty
      }
    },
    saveDate () {
      if (!this.form.date) {
        return
      }
      for (let i = 0; i < this.productList.length; i++) {
        if (this.productList[i].qty - this.productList[i].arrived > 0) {
          this.$alert('货物还未到齐', '提示')
          return
        }
      }
      this.$http.post('/dbapi/po_doc_edit_date', {
        id: this.doc.id,
        date: this.form.date
      }).then(data => {
        this.$close()
      })
    },
    save () {
      let products = this.productList.map(p => {
        return {
          id: p.id,
          arrived: p.arrived,
          arrived_remark: p.arrived_remark
        }
      })
      this.$http.post('/dbapi/po_doc_arrived', {
        id: this.doc.id,
        products
      }).then(data => {
        this.$message({
          type: 'success',
          message: '保存成功!'
        })
      })
    }
  }
}
</script>

<style>
.po-date table {
  width: 100%;
  border-top: 1px solid #999;
  border-left: 1px solid #999;
  border-spacing: 0;
}
.po-date table th,.po-date table td {
  padding: 4px;
  border-right: 1px solid #999;
  border-bottom: 1px solid #999;
}
</style>


